/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GcpSubnet } from '../models/GcpSubnet';

export class ListGcpSubnetsResponse {
  'subnets': Array<GcpSubnet>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "subnets",
      "baseName": "subnets",
      "type": "Array<GcpSubnet>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListGcpSubnetsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

